import styled from "styled-components";

// ขนาดตาม design: ช่อง 18px ห่าง 2px (จอกว้างขยายช่องให้แตะง่ายขึ้น)
export const SeatZoneGridStyled = styled.div`
  --cell: 18px;
  --row-label: 22px;
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  /* แคบกว่า design 2px (layout หน้าเว็บกว้าง 356 ไม่ใช่ 358) ให้จอ 390 เห็นแถวละ 16 ที่ครบไม่ต้องเลื่อน */
  padding: 12px 6px;
  border: 1px solid #d9d9e0;
  border-radius: 10px;
  background: ${({ theme }) => theme.COLORS.WHITE_1};
  @media (min-width: 600px) {
    --cell: 26px;
    --row-label: 28px;
  }
  .zg_header {
    display: flex;
    align-items: center;
    column-gap: 8px;
    .zg_badge {
      padding: 2px 8px;
      border-radius: 6px;
      color: ${({ theme }) => theme.COLORS.WHITE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S12};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_SEMIBOLD};
    }
    .zg_title {
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S13};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
    }
  }
  .zg_stage {
    height: 16px;
    border-radius: 4px;
    background: #ededf5;
    color: #595966;
    font-size: 9px;
    line-height: 16px;
    text-align: center;
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_LIGHT};
  }
  .zg_scroll {
    overflow-x: auto;
  }
  .zg_rows {
    display: flex;
    flex-direction: column;
    row-gap: 2px;
    min-width: max-content;
  }
  .zg_row {
    display: flex;
    align-items: center;
    column-gap: 2px;
    &.by_col {
      display: grid;
      width: max-content;
    }
    .zg_seats {
      flex: 1;
      display: flex;
      justify-content: center;
      column-gap: 2px;
    }
    .zg_seats_contents {
      display: contents;
    }
  }
  .zg_row_label {
    grid-column: 1;
    flex-shrink: 0;
    width: var(--row-label);
    height: var(--cell);
    border-radius: 3px;
    background: #e0e0e5;
    color: #595966;
    font-size: 9px;
    line-height: var(--cell);
    text-align: center;
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
  }
  .zg_seat {
    flex-shrink: 0;
    width: var(--cell);
    height: var(--cell);
    padding: 0;
    border: none;
    border-radius: 3px;
    font-size: 8px;
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
    cursor: pointer;
    &:disabled {
      cursor: default;
    }
    @media (min-width: 600px) {
      font-size: 10px;
    }
  }
`;
